<template>
  <div class="shm-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>详见下方原理说明</div>
    </div>

    <div class="canvas-box">
      <svg width="100%" height="400" viewBox="0 0 400 400">
        <!-- 轴线 -->
        <line x1="50" y1="200" x2="350" y2="200" stroke="#333" stroke-width="1" stroke-dasharray="4,4" />
        <line x1="200" y1="180" x2="200" y2="220" stroke="#555" stroke-width="2" /> <!-- 平衡位置 -->
        <text x="190" y="240" fill="#555" font-size="12">平衡位置</text>

        <!-- 固定端 -->
        <rect x="20" y="150" width="10" height="100" fill="#2c3e50" />

        <!-- 弹簧 -->
        <path :d="springPath" fill="none" stroke="#00d2ff" stroke-width="2" />

        <!-- 振子 -->
        <rect :x="boxX" y="175" width="50" height="50" fill="url(#boxGradient)" stroke="#00d2ff" stroke-width="1" />
        
        <!-- 相图/波形展示 -->
        <path :d="wavePath" fill="none" stroke="#ff4757" stroke-width="1.5" opacity="0.6" />
      </svg>
    </div>

    <div class="controls">
      <div class="slider-row">
        <label>振幅 (A):</label>
        <el-slider v-model="A" :min="20" :max="100" size="mini"></el-slider>
      </div>
      <div class="slider-row">
        <label>频率 (f):</label>
        <el-slider v-model="freq" :min="0.1" :max="1.5" :step="0.1" size="mini"></el-slider>
      </div>
    </div>

    <defs>
      <linearGradient id="boxGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#3498db" />
        <stop offset="100%" stop-color="#2980b9" />
      </linearGradient>
    </defs>
  </div>
</template>

<script>
export default {
  name: 'SimpleHarmonicMotionViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      A: 80,
      freq: 0.5,
      time: 0,
      history: []
    }
  },
  computed: {
    omega() { return 2 * Math.PI * this.freq; },
    x() { return this.A * Math.sin(this.omega * this.time); },
    boxX() { return 200 + this.x - 25; },
    springPath() {
      const startX = 30;
      const endX = this.boxX;
      const width = endX - startX;
      const segments = 25;
      const step = width / segments;
      let d = `M ${startX} 200`;
      for (let i = 1; i <= segments; i++) {
        const px = startX + i * step;
        const py = 200 + (i % 2 === 0 ? -15 : 15) * (i === segments ? 0 : 1);
        d += ` L ${px} ${py}`;
      }
      return d;
    },
    wavePath() {
      if (this.history.length < 2) return "";
      let d = `M ${this.history[0].x} ${this.history[0].y}`;
      for (let i = 1; i < this.history.length; i++) {
        d += ` L ${this.history[i].x} ${this.history[i].y}`;
      }
      return d;
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.time += 0.02;
      this.history.unshift({ x: 200 + this.x, y: 350 });
      // 波形随时间向上卷动
      this.history.forEach(item => { item.y -= 1; });
      if (this.history.length > 200) this.history.pop();
    }, 20);
  },
  beforeDestroy() { clearInterval(this.timer); }
}
</script>

<style scoped lang="scss">
.shm-viz { width: 100%; color: #fff; display: flex; flex-direction: column; gap: 15px; }
.viz-header { display: flex; justify-content: space-between; padding: 10px; background: rgba(255,255,255,0.05); }
.canvas-box { background: #0a0a0a; border-radius: 8px; overflow: hidden; }
.controls { padding: 15px; background: rgba(255,255,255,0.02); .slider-row { display: flex; align-items: center; gap: 15px; label { width: 80px; font-size: 0.85rem; } .el-slider { flex: 1; } } }
</style>
